import { createSelector } from '../reselect';
import { simpleChart2, getNewStatsService, simpleChart, total, safeDivide } from '../generalUtils';

const getNewStats = getNewStatsService('twitter-ads');

const twitterSpend = createSelector([getNewStats], (stats) => {
  return total(stats, 'spend');
});

const twitterSpendChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'spend');
});

const twitterConversionValue = createSelector([getNewStats], (stats) => {
  return total(stats, 'conversionValue');
});

const twitterConversionValueChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'conversionValue');
});

const twitterPurchases = createSelector([getNewStats], (stats) => {
  return total(stats, 'purchases');
});

const twitterPurchasesChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'purchases');
});

const twitterRoas = createSelector(
  [twitterConversionValue, twitterSpend],
  (twitterConversionValue, twitterSpend) => {
    return safeDivide(twitterConversionValue, twitterSpend);
  }
);

const twitterRoasChart = createSelector(
  [getNewStats, twitterConversionValueChart, twitterSpendChart],
  (stats, conversionValue, spend) => {
    return simpleChart2(conversionValue, spend);
  }
);

const twitterImpressions = createSelector([getNewStats], (stats) => {
  return total(stats, 'impressions');
});

const twitterImpressionsChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'impressions');
});
const twitterCpm = createSelector([twitterImpressions, twitterSpend], (impressions, spend) => {
  return safeDivide(spend, impressions / 1000);
});

const twitterCpmChart = createSelector(
  [twitterImpressionsChart, twitterSpendChart],
  (impressions, spend) => {
    return simpleChart2(spend, impressions, { chart1yMultiplier: 1000 });
  }
);

const twitterClicks = createSelector([getNewStats], (stats) => {
  return total(stats, 'clicks');
});

const twitterClicksChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'clicks');
});

const twitterEngagements = createSelector([getNewStats], (stats) => {
  return total(stats, 'engagements');
});

const twitterEngagementsChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'engagements');
});

const twitterFollows = createSelector([getNewStats], (stats) => {
  return total(stats, 'follows');
});

const twitterFollowsChart = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, 'follows');
});

const twitterCpa = createSelector(
  [getNewStats, twitterSpend, twitterPurchases],
  (stats, spend, purchases) => {
    return safeDivide(spend, purchases);
  }
);

const twitterCpaChart = createSelector(
  [getNewStats, twitterSpendChart, twitterPurchasesChart],
  (stats, spend, purchases) => {
    return simpleChart2(spend, purchases);
  }
);

const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    twitterClicks,
    twitterClicksChart,
    twitterSpend,
    twitterSpendChart,
    twitterConversionValue,
    twitterConversionValueChart,
    twitterPurchases,
    twitterPurchasesChart,
    twitterImpressions,
    twitterImpressionsChart,
    twitterEngagements,
    twitterEngagementsChart,
    twitterCpm,
    twitterCpmChart,
    twitterFollows,
    twitterFollowsChart,
    twitterCpa,
    twitterCpaChart,
    twitterRoas,
    twitterRoasChart,
    twitter_complete_payment_roas: twitterRoas,
    twitter_spend: twitterSpend,
  },
};
